/*
 * Temaets eneste JavaScript.
 *
 * Accordions er <details>-elementer og virker uden dette script — det sørger kun for at
 * åbning af ét punkt lukker de øvrige i samme gruppe, som designet foreskriver
 * ("first item open, others closed").
 *
 * Der er bevidst ikke mere end dette. Alt indhold på katalog- og artikelsider skal stå i
 * HTML'en ved første load.
 */
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.accordion__summary')
  if (!summary) return

  const item = summary.parentElement
  const group = item.closest('.accordion')
  if (!group) return

  // Klikket er endnu ikke behandlet af browseren, så `open` er stadig den gamle værdi.
  // Er punktet ved at blive åbnet, lukkes søskende først.
  if (!item.open) {
    const closedAbove = [...group.querySelectorAll('.accordion__item[open]')].some(
      (other) => other !== item && other.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING,
    )
    group.querySelectorAll('.accordion__item[open]').forEach((other) => {
      if (other !== item) other.open = false
    })
    /*
     * ⚠ ET LUKKET SPØRGSMAL OVER DET KLIKKEDE FLYTTER SIDEN.
     *
     * Lukningen herover sker SYNKRONT, før browseren selv åbner det klikkede punkt. Lå det
     * åbne spørgsmål OVER det man klikkede, kollapser et langt svar oven over, og siden
     * hopper op til 531 px væk fra punktet man lige trykkede på — man mister sit sted.
     * `scrollIntoView` genankrer punktet, så klikket altid lander hvor man forventer det.
     */
    if (closedAbove) summary.scrollIntoView({ block: 'nearest' })
  }
})

/*
 * Hovedmenuens panel er `<details class="header__menu">` og virker uden dette script —
 * samme begrundelse som accordions. Men et `<details>` lukker hverken på Escape eller på
 * klik udenfor sig selv, og en skærmlæser- eller tastaturbruger havde ingen vej ud af
 * panelet uden at tabbe sig hele vejen igennem det.
 */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return
  const menu = document.querySelector('.header__menu[open]')
  if (!menu) return
  menu.open = false
  menu.querySelector(':scope > summary')?.focus()
})

document.addEventListener('click', (event) => {
  const menu = document.querySelector('.header__menu[open]')
  if (!menu) return
  if (menu.contains(event.target)) return
  // Panelet (`.header__nav`) er en SØSKENDE til `.header__menu`, ikke et barn af det.
  const nav = menu.nextElementSibling
  if (nav && nav.contains(event.target)) return
  menu.open = false
})
